import react, { useState } from "react";
import PlaceSearch from "./PlaceSearch/PlaceSearch";

const Location = ({ visible, handleChangeForm, form }) => {

  return (
    <div
      className="row"
      style={{ marginTop: "30px", display: !visible ? "none" : "block" }}
    >
      <PlaceSearch placeInfo={form} searchData={(e) => handleChangeForm(e)} />
    </div>
  );
};

export default Location;
